<template>
  <div id="cards">
    <div>
      <div class="row">
        <div class="col-6">
          <div class="row">
            <div class="col-12 subtitle">
              Day #1
            </div>
          </div>
          <div
            class="row"
            v-for="i in day1.AgendaItems"
            :key="i.Id"
          >
            <div class="col-2 text-right item">
              {{ timeFormatter(i.StartTime) }}
            </div>
            <div class="col-5 item">
              {{ i.Topic }}
            </div>
            <div class="col-3 item">
              {{ i.LocationInfo }}
            </div>
            <div class="col-1 text-center item">
              {{ i.CurriculumReference }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-12 subtitle">
              Day #2
            </div>
          </div>
          <div
            class="row"
            v-for="i in day2.AgendaItems"
            :key="i.Id"
          >
            <div class="col-2 item">
              {{ timeFormatter(i.StartTime) }}
            </div>
            <div class="col-4 item">
              {{ i.Topic }}
            </div>
            <div class="col-3 item">
              {{ i.LocationInfo }}
            </div>
            <div class="col-2 item">
              {{ i.CurriculumReference }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div
            class="row"
            align-h="center"
          >
            <div class="col-12 subtitle">
              Day #3
            </div>
          </div>
          <div
            class="row"
            v-for="i in day3.AgendaItems"
            :key="i.Id"
          >
            <div class="col-2 item pl-2 ml-2">
              {{ timeFormatter(i.StartTime) }}
            </div>
            <div class="col-4 item">
              {{ i.Topic }}
            </div>
            <div class="col-3 item">
              {{ i.LocationInfo }}
            </div>
            <div class="col-2 item">
              {{ i.CurriculumReference }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div
            class="row"
            align-h="center"
          >
            <div class="col-12 subtitle">
              Day #4
            </div>
          </div>
          <div
            class="row"
            v-for="i in day4.AgendaItems"
            :key="i.Id"
          >
            <div class="col-2 item">
              {{ timeFormatter(i.StartTime) }}
            </div>
            <div class="col-4 item">
              {{ i.Topic }}
            </div>
            <div class="col-3 item">
              {{ i.LocationInfo }}
            </div>
            <div class="col-2 item">
              {{ i.CurriculumReference }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div
            class="row"
            align-h="center"
          >
            <div class="col-2 subtitle">
              Day #5
            </div>
          </div>
          <div
            class="row"
            v-for="i in day5.AgendaItems"
            :key="i.Id"
          >
            <div class="col-2 item pl-2 ml-2">
              {{ timeFormatter(i.StartTime) }}
            </div>
            <div class="col-4 item">
              {{ i.Topic }}
            </div>
            <div class="col-3 item">
              {{ i.LocationInfo }}
            </div>
            <div class="col-2 item">
              {{ i.CurriculumReference }}
            </div>
          </div>
        </div>
        <div class="col-6" />
      </div>
    </div>
  </div>
</template>

<script>

import formatter from '@/services/formatter.js'

export default {
  name: 'PrintCourseScheduleCards',
  props: {
    agendas: {
      type: Array,
      default: function () {
        return []
      }
    },
    staff: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      day1: {},
      day2: {},
      day3: {},
      day4: {},
      day5: {},
      printCellStyle: { font: '9pt Raleway', margin: '0', padding: '0' },
      printHeaderCellStyle: { font: '9pt Raleway' },
      isLazy: true
    }
  },
  mounted () {
    for (let i = 0; i < this.agendas.length; i++) {
      if (this.agendas[i].AgendaName === 'Day #1') {
        this.day1 = this.agendas[i]
      } else if (this.agendas[i].AgendaName === 'Day #2') {
        this.day2 = this.agendas[i]
      } else if (this.agendas[i].AgendaName === 'Day #3') {
        this.day3 = this.agendas[i]
      } else if (this.agendas[i].AgendaName === 'Day #4') {
        this.day4 = this.agendas[i]
      } else if (this.agendas[i].AgendaName === 'Day #5') {
        this.day5 = this.agendas[i]
      }
    }
  },
  methods: {
    timeFormatter: function (params) {
      return formatter.formatAsTime(params)
    },
    dateFormatter: function (params) {
      return formatter.formatAsDate(params)
    },
    getPresenterName: function (presenterScouterKey) {
      const scouter = this.staff[presenterScouterKey]

      if (scouter === undefined) {
        return ''
      } else {
        return scouter
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  font-size: 40px;
  margin-top: 60px;
  margin-bottom: 24px;
}
.subtitle {
  font-size: 20px;
  margin-bottom: 24px;
}
.item {
  border: 1px solid black;
  font-size: 9px;
  padding-left: 10px;
  padding-right: 10px;
}
#cards {
  margin-left: 95px;
}
</style>
